import React from 'react'
import { Container, Text } from '@chakra-ui/react'

interface AuthLayoutPropsType {
  title: string
  description: React.ReactElement
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutPropsType> = ({
  title,
  description,
  children
}) => {
  return (
    <Container maxW={'1400px'} mt={32} mb={32}>
      <Text textStyle={'sectionHeader'} textAlign={'center'}>
        {title}
      </Text>
      {description}
      {children}
    </Container>
  )
}

export default AuthLayout
